<div class="d-flex flex-wrap">
  <mat-card class="s-p-2 rounded card-shadow flex-grow-1">
    <div class="d-flex align-items-center">
      <div
        class="circle d-flex align-items-center justify-content-center s-w-14 s-h-14 rounded-circle"
        [style.background-color]="card().iconBackgroundColor ?? '#eeeeee'"
      >
        <mat-icon
          class="material-icons s-heading-2 c-primary-brand-color"
          [style.color]="card().iconColor"
          color="primary"
        >
          {{ card().icon }}
        </mat-icon>
      </div>
      <div class="s-ms-3">
        <h2 class="c-card-title margin-0">
          {{ card().value }}
        </h2>
        <p class="mt-1 c-card-subtitle">
          {{ card().title }}
        </p>
      </div>
    </div>
    <div class="see-more" *ngIf="card().path">
      <a href="test"> Ver mais </a>
    </div>
  </mat-card>
</div>
